module.exports = __webpack_public_path__ + "img/6fcd75780928c38c004f7cba95e5a94f.9807d847.jpg";